import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import AiCostWorkbookExportButton from '@UI/Pages/Administration/AiCosts/AiCostWorkbookExportButton';
import AiCostsContent from '@UI/Pages/Administration/AiCosts/AiCostsContent';
import AiCostsNotifications from '@UI/Pages/Administration/AiCosts/AiCostsNotifications';
import AiCostLimitFormNotifications from '@UI/Pages/Administration/Shared/AiCostLimitFormNotifications';
import type * as React from 'react';

/** No destructive action, hence no confirmation. Closed behind `AI_USAGE_READ` by the route guard. */
const AiCostsPage: React.FC = () => {
	return (
		<PageContainer>
			<PageHeader
				eyebrow="ADMINISTRATION · PILOTAGE"
				title="Coûts d'IA"
				description="Ce que coûtent les audios et les documents générés, où et par qui. Coût estimé, figé au moment du traitement : ce n'est pas la facture du fournisseur."
				actions={<AiCostWorkbookExportButton />}
			/>
			<AiCostsContent />
			<AiCostsNotifications />
			<AiCostLimitFormNotifications />
		</PageContainer>
	);
};

export default AiCostsPage;
